import { render, staticRenderFns } from "./MessageListDialog.vue?vue&type=template&id=0faeabdb&scoped=true&"
import script from "./MessageListDialog.vue?vue&type=script&lang=js&"
export * from "./MessageListDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessageListDialog.vue?vue&type=style&index=0&id=0faeabdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faeabdb",
  null
  
)

export default component.exports